/**
 * @file userCenterModules.js
 * @description 个人中心子模块名称、标题、组件映射（与存量路由 params.module 一致）
 * @module features/user/constants/userCenterModules
 */

import Balance from '@/features/user/components/OperationArea/Balance.vue'
import Membership from '@/features/user/components/OperationArea/Membership.vue'
import PurchaseHistory from '@/features/user/components/OperationArea/PurchaseHistory.vue'
import UserBaseInfo from '@/features/user/components/OperationArea/UserBaseInfo.vue'
import UserFavorites from '@/features/user/components/OperationArea/UserFavorites.vue'
import UserHistory from '@/features/user/components/OperationArea/UserHistory.vue'
import UserFeedback from '@/features/user/components/OperationArea/UserFeedback.vue'
import UserAccountBinding from '@/features/user/components/OperationArea/UserAccountBinding.vue'
import UserPasswordSetting from '@/features/user/components/OperationArea/UserPasswordSetting.vue'

/** 可导航的子模块 name（与路由 params.module、activeComponent 字符串一致） */
export const USER_CENTER_VALID_MODULES = [
  'Balance',
  'Membership',
  'PurchaseHistory',
  'UserBaseInfo',
  'UserFavorites',
  'UserHistory',
  'UserFeedback',
  'UserAccountBinding',
  'UserPasswordSetting',
]

/**
 * 暂从导航隐藏的模块（组件与映射保留，便于日后恢复）
 * - Balance：余额充值中心改走弹窗
 * - UserPasswordSetting：当前以手机号注册登录，暂不提供密码设置
 */
export const USER_CENTER_HIDDEN_MODULES = new Set([
  'Balance',
  'UserPasswordSetting',
])

/** 个人中心桌面默认可见模块 */
export const DEFAULT_USER_CENTER_MODULE = 'UserBaseInfo'

/**
 * 将路由/书签中的模块名解析为当前可见模块；隐藏项落到基本资料
 * @param {string} [module]
 * @returns {string}
 */
export function resolveVisibleUserCenterModule(module) {
  if (!module || USER_CENTER_HIDDEN_MODULES.has(module)) {
    return DEFAULT_USER_CENTER_MODULE
  }
  if (USER_CENTER_VALID_MODULES.includes(module)) return module
  return DEFAULT_USER_CENTER_MODULE
}

/** 移动端 UserModule 页标题 */
export const USER_CENTER_MODULE_TITLES = {
  Balance: '当前余额',
  Membership: '漫币会员',
  PurchaseHistory: '金币记录',
  UserBaseInfo: '基础信息',
  UserFavorites: '我的收藏',
  UserHistory: '观看历史',
  UserFeedback: '我的反馈',
  UserAccountBinding: '绑定账号',
  UserPasswordSetting: '密码设置',
}

/** 模块名 → 组件（桌面端 operation-area 动态组件） */
export const USER_CENTER_MODULE_COMPONENTS = {
  Balance,
  Membership,
  PurchaseHistory,
  UserBaseInfo,
  UserFavorites,
  UserHistory,
  UserFeedback,
  UserAccountBinding,
  UserPasswordSetting,
}
